
import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

interface MarketingEffortsSectionProps {
  marketingEfforts: string;
  updateBusinessData: (key: string, value: any) => void;
}

const MarketingEffortsSection: React.FC<MarketingEffortsSectionProps> = ({ 
  marketingEfforts, 
  updateBusinessData
}) => {
  const onChange = (value: string) => {
    updateBusinessData('marketingEfforts', value);
  };

  return (
    <div className="space-y-2">
      <Label htmlFor="marketing-efforts">Current Marketing Efforts</Label>
      <Textarea
        id="marketing-efforts"
        placeholder="Describe your current marketing activities and channels..."
        className="resize-none"
        rows={4}
        value={marketingEfforts}
        onChange={(e) => onChange(e.target.value)}
      />
      <p className="text-sm text-muted-foreground mt-1">
        This helps us understand your current strategies and find areas for improvement.
      </p>
    </div>
  );
};

export default MarketingEffortsSection;
